import React, { PureComponent } from 'react'
import { Button, Form, Message, Modal } from 'semantic-ui-react'
import { Link, Redirect } from 'react-router-dom'
import { Container, Segment, Divider, Card } from 'semantic-ui-react'
import SignIn from '../components/SignIn'
import Register from '../components/Register'
import { isAuthenticated } from '../services/self'
import { confirmMarketplaceSubscription } from '../services/api-catalog'
import { getQueryString } from '../services/misc'
import background from '../blur-background.jpg'
import logo from '../logo.png'

var fullBackground = {
	backgroundImage: `url(${background})`,
	height: "100%",
	width: "100%"
};

var fullContainer = {
	height:"100vh",
	width: "100%"
}

var form = {
	backgroundColor:"white",
	martinTop:"0"
}

var formFontSize = {
	fontSize: "14px"
}

export default class HomePage extends PureComponent {
  constructor() {
    super()
    this.state = {}

    const { usagePlanId, token } = getQueryString()
    if (usagePlanId && token) {
      this.state = { usagePlanId, token }

      if (isAuthenticated()) {
        confirmMarketplaceSubscription(usagePlanId, token).then(() => {
          window.location.href = '/apis'
        })
      }
    }
  }

  render() {
		if(isAuthenticated()) {
			return(<Redirect to="/apis"/>)
		} else {
			return (
				<div style={fullContainer}>
					<div className="App-background" style={fullBackground}>
						<div className="App-header">
							<Link to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
							<div className="captionText relativePosition">for developers</div>
							{ isAuthenticated() ? '' : (
								<div className="relativePosition">
									<div className="signInBtnPosition">
										<SignIn usagePlanId={this.state.usagePlanId} token={this.state.token}/>
									</div>
									<div className="registerBtnPosition">
										<Register usagePlanId={this.state.usagePlanId} token={this.state.token} />
									</div>
									<div className="docsBtnPosition">
										<Link to='/documentation'><Button className="docsBtn">DOCUMENTATION</Button></Link>
									</div>
								</div>
							)}
						</div>
						<div className="container-fluid">
							<div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12">
							<br/>
								<div className="formBox formBoxCustomPadding" style={{height:"400px"}}>
									<div className="containerWrapper">
										<span style={{fontSize:"50px", color:"black", textShadow:"1px 1px white"}}>Building applications through integration</span>
										<br/><br/>
										<span style={{fontSize:"25px",color:"black", textShadow:"1px 1px white"}}>Asian Hospital and Medical Center's Official API</span>
										<br/><br/><br/><br/>
										<Register usagePlanId={this.state.usagePlanId} token={this.state.token} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
	    )
		}
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Home.js
 **/